import { useEffect } from 'react';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../services/api';
import { useAuthStore } from '../stores/authStore';

export function useAuth() {
  const { user, token, isAuthenticated, login, logout, initialize } = useAuthStore();
  const navigate = useNavigate();

  useEffect(() => {
    initialize();
  }, [initialize]);

  const loginMutation = useMutation({
    mutationFn: ({ email, password }: { email: string; password: string }) =>
      authAPI.login(email, password),
    onSuccess: (response) => {
      login(response.data.token, response.data.user);
      navigate('/admin');
    },
  });

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  return {
    user,
    token,
    isAuthenticated,
    login: loginMutation.mutate,
    logout: handleLogout,
    isLoading: loginMutation.isPending,
    error: loginMutation.error,
  };
}
